import { Component, OnInit } from '@angular/core';

// Importaciones de servicios.
import { MeService } from '../../services/me.service';

// Importaciones de interfaces.
import { IEmployee } from '../../interfaces/employee.interface';

/**
 * Componente de configuración.
 *
 * Este componente proporciona una interfaz para que los usuarios gestionen y personalicen
 * las configuraciones de la aplicación. Puede incluir opciones relacionadas con la cuenta,
 * preferencias del sistema y otras configuraciones ajustables.
 */
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  standalone: false,
})
export class SettingsComponent implements OnInit {
  loading: boolean = false;
  isAdminRole: boolean = false;

  constructor(private meService: MeService) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;

    try {
      const meResponse: IEmployee = await this.meService.get();
      this.isAdminRole = meResponse.role.name === 'admin_role';
    } finally {
      this.loading = false;
    }
  }
}
